export enum SaleStatus {
  OPEN = 'OPEN',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

export enum SaleEvent {
  ADDITIONAL_SPEND_UPDATED = 'TL_SALE_ADDITIONAL_SPEND_UPDATED',
  UPDATED = 'TL_SALE_UPDATED',
  CREATED = 'TL_SALE_CREATED',
}

export enum SaleCommissionType {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT',
}

export enum SaleClient {
  WEB = 'web',
  WEB_FAST_PASS = 'web-fast-pass',
  IOS = 'ios',
  ANDROID = 'android',
  WIDGET = 'widget',
  QR_CODE = 'qr-code',
}
